import { useQuery } from '@tanstack/react-query';
import React, { useMemo } from 'react';
import Navbar from '../../../components/Navbar';
import useAxiosPrivate from '../../../hooks/useAxiosPrivate';
import { MaterialReactTable } from 'material-react-table';

import Loaders from '../../../components/Loaders';
import { Link } from 'react-router-dom';
import { Switch } from '@mui/material';

export default function Promotion() {
    const axiosPrivate = useAxiosPrivate();


    const handlePromotion = () => {
        const res = axiosPrivate.get(`promotional-campaign/all`)
        return res;
    };
    const handlePromotionStatus = async (id, value) => {
        const response = await axiosPrivate.put(`promotional-campaign/is_active/${id}`, {
            status: value
        });
        refetch()
        return response;
    }


    const columns = useMemo(
        () => [
            {
                accessorFn: (row) => <img src={row.image} alt="Images" height='50px' />,
                header: "Image",
                muiTableHeadCellProps: { sx: { color: "#9C6EAA" } },
                Cell: ({ renderedCellValue }) => <strong>{renderedCellValue}</strong>
            },
            {
                accessorFn: (row) => row.name,
                header: "Name",
                muiTableHeadCellProps: { sx: { color: "#9C6EAA" } },
                Cell: ({ renderedCellValue }) => <strong>{renderedCellValue}</strong>
            },
            {
                accessorFn: (row) => row.campaign_type,
                header: "Campaign type",
                muiTableHeadCellProps: { sx: { color: "#9C6EAA" } },
                Cell: ({ renderedCellValue }) => <strong>{renderedCellValue}</strong>
            },

            {
                accessorFn: (row) => <Switch defaultChecked={row.is_active} onChange={(e) => handlePromotionStatus(row.id, e.target.checked)} />,
                header: "Status",
                muiTableHeadCellProps: { sx: { color: "#9C6EAA" } },
                Cell: ({ renderedCellValue }) => <strong>{renderedCellValue}</strong>
            },
            {
                accessorFn: (row) => (
                    <>
                        <Link to={`/admin/dashboard/promotions/edit/${row.id}`} className='btn btn-success '><i className="fa-regular fa-pen-to-square"></i></Link>
                    </>
                ),
                id: "action", //id required if you use accessorFn instead of accessorKey
                header: "Action",
                Header: <i style={{ color: "red" }}>Action</i> //
            }
        ],
        [],
    );

    const { data: allPromotions = [], isLoading, refetch } = useQuery({
        queryKey: ['get-Promotion'],
        queryFn: handlePromotion,
        cacheTime: 5000,
    })
    return (
        <>
            <Navbar
                title="Promotion"
                btnTitle="Add New Promotion"
                btnLink="/admin/dashboard/promotions/create"
            />
            {
                isLoading && <div className="d-flex justify-content-center align-items-center">
                    <Loaders />
                </div>
            }



            <div className='container my-5'>


                {allPromotions?.data?.data &&
                    <>
                        <MaterialReactTable
                            columns={columns}
                            data={allPromotions?.data?.data}
                        />
                    </>
                }
            </div>
        </>
    )
}
